import { useMutation, useQueryClient } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";

const useInitiateRefund = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (refundId) =>
      request({
        url: `/payment/issueRefundById/${refundId}`,
        method: "POST",
      }),
    {
      onSuccess: () => {
        toast.success("Refund initiation triggered");
        // Refetch refund lists so the table shows updated status (and stays correct after refresh)
        queryClient.invalidateQueries({ queryKey: ["get-refunds-by-order-id"] });
        queryClient.invalidateQueries({ queryKey: ["get-all-refunds"] });
      },
      onError: (error) => {
        const msg =
          error?.response?.data?.error ||
          error?.message ||
          "Failed to initiate refund";
        toast.error(msg);
      },
    }
  );
};

export default useInitiateRefund;